import { type ClassValue, clsx } from "clsx";
import { composeRenderProps } from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { tv } from "tailwind-variants";

export function mergeClassNames(...classValues: ClassValue[]) {
  return twMerge(clsx(classValues));
}

export const focusRing = tv({
  base: "outline-ring/70 outline-offset-2 forced-colors:outline-[Highlight]",
  variants: {
    isFocusVisible: {
      true: "outline-2",
      false: "outline-0",
    },
  },
});

export const focusStyles = tv({
  base: "outline-ring/70 forced-colors:outline-[Highlight]",
  variants: {
    isFocused: {
      true: "outline-2 outline-offset-2",
      false: "outline-0",
    },
  },
});

export const focusButtonStyles = tv({
  base: "outline-ring/70 forced-colors:outline-[Highlight]",
  variants: {
    isFocusVisible: {
      true: "outline-2 outline-offset-2",
      false: "outline-0",
    },
  },
});

export function composeTailwindRenderProps<T>(
  existingClassName: string | ((v: T) => string) | undefined,
  tailwindClasses: string,
): string | ((v: T) => string) {
  return composeRenderProps(existingClassName, (previousClassName) =>
    twMerge(tailwindClasses, previousClassName),
  );
}
